<template>
  <div class="py-4 container-fluid">
    <GridRow>
      <GridCol :size="12">
        <MetaSection title="Monitoring Hasil">
          <!-- <div class="text-right">
            <ArgonButton :to="{ name: 'Create Assignment KPI Pegawai' }" isRouteLink>+ Tambah Assignment KPI</ArgonButton>
          </div> -->
        </MetaSection>
      </GridCol>
      <GridCol :size="12">
        <!-- <CardComponent :useHeader="true"> -->
        <CardComponent use-header>
          <template v-slot:header-action>
            <GridRow class="w-100 mb-2">
              <GridCol :size="12">
                <div class="d-flex align-items-center justify-content-start gap-2">
                  <InputGroup class="m-0 filter">
                    <template v-slot:prepend>
                      <i class="fas fa-search" aria-hidden="true"></i>
                    </template>
                    <input v-model="params.keyword" @keyup="searchKeyword()" type="text" class="form-control"
                      placeholder="Cari NIP/nama pegawai..." style="border-right: 1px solid #d2d6da!important;">
                  </InputGroup>

                  <!-- <FormGroup class="m-0 w-100">
                    <select @change="getData()" name="status" id="status" class="form-control" v-model="params.status">
                      <option value="">Semua Status</option>
                      <option value="1">Aktif</option>
                      <option value="0">Non Aktif</option>
                    </select>
                  </FormGroup> -->

                  <FormGroup class="m-0 filter">
                    <model-list-select
                      class="form-control"
                      v-model="params.hasil"
                      :list="result_list.map((item) => {return {item:item}})"
                      option-value="item"
                      option-text="item"
                      placeholder="Semua Hasil"
                    />
                  </FormGroup>
                </div>
              </GridCol>
            </GridRow>
          </template>

          <div class="table-responsive">
            <table class="table">
              <thead>
                <tr>                  
                  <th
                    v-for="item in thead"
                    :key="item"
                    class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2"
                  >
                    {{ item }}
                  </th>
                  <th class="text-uppercase text-secondary text-xxs font-weight-bolder opacity-7 px-2">Aksi</th>
                </tr>
              </thead>
              <tbody>
                <tr v-if="data.length < 1">
                  <td :colspan="thead.length+1" class="text-center text-secondary">Data tidak ditemukan</td>
                </tr>
                <tr v-for="(item, index) in data" :key="index">
                  <td class="font-weight-bolder">{{ item?.periode || '-' }}</td>
                  <!-- <td>{{ item?.diajukan || '-' }}</td> -->
                  <td>{{ moment(item?.diajukan).locale('id').format('DD MMM YYYY HH:mm') }}</td>
                  <!-- <td>
                    <argon-badge :color="status?.[index]?.color || status?.[0]?.color">{{ status?.[index]?.label || status?.[0]?.label }}</argon-badge>
                  </td> -->
                  <td>
                    <span
                      v-if="item?.indeks_penilaian"
                      style="padding: .5rem .9rem"
                      class="rounded-circle text-white text-lg text-bold"
                      :class="result_color?.[item.indeks_penilaian] || 'bg-secondary'"
                    >
                      {{ item.indeks_penilaian }}
                    </span>
                    <span v-else>-</span>
                  </td>
                  <td>{{ item?.is_arsip || '-' }}</td>

                  <td>
                    <ThreeDotsMenu>
                      <!-- <router-link :to="{ name: 'Ubah Assignemnt KPI Pegawai', params: { id: item?.id ?? 0 } }"
                        class="text-secondary font-weight-bold text-xs" data-toggle="tooltip"
                        data-original-title="Edit assignment">Edit</router-link>
                      <button @click.prevent="deleteData(item.id)"
                        class="text-secondary font-weight-bold text-xs btn btn-link" role="link" data-toggle="tooltip"
                        data-original-title="Delete user">Hapus</button> -->

                      <router-link :to="{ name: 'Monitoring Hasil Detail', params: { realization_id: item.realization_id, periode_id: item.periode_id } }">
                        Detail
                      </router-link>

                      <a
                        href="#"
                        v-if="item?.is_arsip === '-'"
                        @click="archieveData({
                          is_arsip: true,
                          realization_id: item.realization_id,
                          periode_id: item.periode_id,
                        })"
                        class=""
                      >
                        Arsipkan
                      </a>
                    </ThreeDotsMenu>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <!-- <div class="d-flex flex-row flex-wrap gap-2 justify-content-center align-items-center">
            <button type="button" @click="params.page = params.page - 1"
              class="btn btn-light rounded-circle"><font-awesome-icon icon="fa-solid fa-chevron-left" /></button>
            <p>{{ metaData?.current_page ?? "&infin;" }} / {{ metaData?.total_page ?? "&infin;" }}</p>
            <button type="button" @click="params.page = params.page + 1"
              class="btn btn-light rounded-circle"><font-awesome-icon icon="fa-solid fa-chevron-right" /></button>
          </div> -->

          <ArgonPagination
            :page="params.page"
            :total_page="metaData?.total_page"
            :current_page="metaData?.current_page"
            @changepage="getData"
            @changelimit="changeLimit"
          />
        </CardComponent>
      </GridCol>
    </GridRow>
  </div>
</template>

<script>
import CardComponent from '@/components/CardComponent.vue';
import InputGroup from '@/components/InputGroup.vue';
import { ModelListSelect } from "vue-search-select";
import "vue-search-select/dist/VueSearchSelect.css";
// import ArgonBadge from '@/components/ArgonBadge.vue';
// import ArgonButton from '@/components/ArgonButton.vue';
import ArgonPagination from '@/components/ArgonPagination.vue';
import ThreeDotsMenu from '@/components/ThreeDotsMenu.vue';
import FormGroup from '@/components/FormGroup.vue';
import MetaSection from '@/components/MetaSection.vue';
import GridRow from '@/components/grid/GridRow.vue';
import GridCol from '@/components/grid/GridCol.vue';
import moment from 'moment';

import MonitoringHasilApi from '@/repository/api/MonitoringHasilApi';

export default {
  name: "tables",
  components: {
    // ArgonButton,
    ArgonPagination,
    CardComponent,
    InputGroup,
    // ArgonBadge,
    ThreeDotsMenu,
    FormGroup,
    MetaSection,
    GridRow,
    GridCol,
    ModelListSelect,
  },
  data() {
    return {
      moment, 
      timer: null,
      data: [],
      metaData: {},
      params: {
        employee_id: '',
        keyword: "",
        // status: "",
        hasil: "",
        limit: 10,
        page: 1,
      },
      thead: [
        'Priode KPI',
        'Tanggal Diajukan',
        // 'Status',
        'Hasil',
        'Keterangan',
        '', // actions
      ],
      result_list: ['A', 'B', 'C', 'D', 'E', 'F'],
      result_color: {
        A: 'bg-success',
        B: 'bg-info',
        C: 'bg-warning',
        D: 'bg-warning',
        E: 'bg-danger',
        F: 'bg-danger',
      },
      status: [
        {
          label: 'Diajukan',
          color: 'info',
        },
        {
          label: 'Disetujui',
          color: 'success',
        },
        {
          label: 'Ditolak',
          color: 'danger',
        },
      ],
    };
  },
  watch: {
    'params.hasil': {
      handler: async function () {
        await this.getData();
      }
    },
    // 'params.page': {
    //   handler: async function (newVal, oldVal) {
    //     if (newVal < 1) {
    //       this.params.page = oldVal
    //     } else {
    //       // await this.getJabatan();
    //       await this.getData(newVal);
    //     }
    //   },
    //   deep: false,
    // },
  },
  methods: {
    async searchKeyword() {
      clearTimeout(this.timer)
      this.timer = setTimeout(async () => {
        await this.getData();
      }, 650);
    },
    changeLimit(limit) {
      this.params.limit = limit;
      this.getData();
    },
    async getData(page=1) {
      this.$store.state.loading = true;
      this.data = [];
      this.metaData = {};
      this.params.page = page;

      await MonitoringHasilApi.getList(this.params)
        .then((response) => {
          this.data = response?.data;
          
          this.metaData = {
            status: response?.status ?? null,
            message: response?.message ?? null,
            total_item: response?.total_item ?? null,
            per_page: response?.per_page ?? null,
            total_page: response?.total_page ?? null,
            current_page: response?.current_page ?? null,
          };
        }).catch((error) => {
          console.log(error)
          // if ((error?.response?.data?.detail ?? "") == 'Invalid page.') {
          //   this.params.page = this.params.page - 1;
          // }
        });

      this.$store.state.loading = false;
    },
    archieveData(item_data) {
      this.$swal({
        icon: 'warning',
        title: 'Arsipkan KPI?',
        text: 'Beri alasan KPI diarsipkan.',
        showCancelButton: true,
        // input reason
        input: 'textarea',
        // inputLabel: 'Reason',
        inputPlaceholder: 'Tulis alasan disini...',
        inputAttributes: {
          'aria-label': 'Tulis alasan disini',
        },
        // eslint-disable-next-line consistent-return
        inputValidator: (value) => {
          if (!value) {
            return 'Tuliskan alasan!';
          }
        },
      }).then(async (result) => {
        if (result.isConfirmed) {
          this.$store.state.loading = true;
          item_data.catatan = result.value;

          await MonitoringHasilApi.archieveData(item_data)
            .then((resp) => {
              if (!resp?.error) {
                this.params.page = 1;
                this.getData();

                this.$swal({
                  icon: 'success',
                  title: 'KPI berhasil diarsipkan.',
                });
              } else {
                this.$swal({
                  icon: 'error',
                  title: resp?.error?.message || 'Something wrong, please try again.',
                });
              }
            })
            .catch((err) => {
              console.log(err);
              this.$swal({
                icon: 'error',
                title: 'Something wrong, please try again.',
              });
            });
          this.$store.state.loading = false;
        }
      });
    },
  },
  async mounted() {
    this.$store.state.loading = true;
    await this.getSessionUser();
    this.params.employee_id = this.$store.state?.sessionUser?.employee?.id || '';
    this.getData();
  },
};
</script>
